import { SliderPrimitive } from '@figma/fpl-components';
import styles from './DrawStyleSlider.module.css';

export type DrawStyleSliderProps = {
  'aria-label': string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
  bigStep: number;
  disabled?: boolean;
  rangeAnchor?: number;
};

/** The compact slider appearance used by Figma's DrawStyleSlider. */
export function DrawStyleSlider({ rangeAnchor, ...props }: DrawStyleSliderProps) {
  return (
    <SliderPrimitive.Root {...props} className={styles.root}>
      {rangeAnchor !== undefined && (
        <SliderPrimitive.Range className={styles.range} start={rangeAnchor} end={props.value} />
      )}
      <SliderPrimitive.Thumb className={styles.thumb} />
    </SliderPrimitive.Root>
  );
}
